<form [formGroup]="form"
      (ngSubmit)="onSubmit($event)">
  <div class="fields">
    <mat-form-field>
      <mat-label>Название</mat-label>
      <input matInput
             formControlName="search"
             type="text"
             autocomplete="off"
             [autofocus]="['autofocus']">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Тип</mat-label>
      <mat-select formControlName="type">
        <mat-option>Любой</mat-option>
        <mat-option value="COMMON">Общий тест</mat-option>
        <mat-option value="HR">HR тест</mat-option>
        <mat-option value="AT">AT тест</mat-option>
        <mat-option value="FT">FT тест</mat-option>
        <mat-option value="TEST">Тестовый</mat-option>
        <mat-option value="POLL">Опрос</mat-option>
        <mat-option value="ANON">Анонимный опрос</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Статус</mat-label>
      <mat-select formControlName="isActivated">
        <mat-option>Любой</mat-option>
        <mat-option value="true">Активен</mat-option>
        <mat-option value="false">Неактивен</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="buttons">
    <button mat-flat-button
            color="primary"
            type="submit"
            (click)="onSubmit($event)">Применить
    </button>
    <button mat-flat-button
            type="button"
            (click)="onClear($event)">Очистить
    </button>
  </div>
</form>
